import React, { useEffect, useLayoutEffect, useRef } from 'react';
import LibInfiniteScroll from 'react-infinite-scroll-component';
import { prefersReducedMotion, revealElement } from 'utils/revealAnimation';
function InfiniteScroll(props) {
    const { dataLength } = props;
    const wrapRef = useRef(null);
    const observerRef = useRef(null);
    const previousLengthRef = useRef(dataLength);
    useEffect(() => {
        if (!wrapRef.current || typeof MutationObserver === 'undefined') {
            return undefined;
        }
        const observer = new MutationObserver(() => { });
        observer.observe(wrapRef.current, { childList: true, subtree: true });
        observerRef.current = observer;
        return () => {
            observer.disconnect();
            observerRef.current = null;
        };
    }, []);
    useLayoutEffect(() => {
        var _a, _b;
        const records = (_b = (_a = observerRef.current) === null || _a === void 0 ? void 0 : _a.takeRecords()) !== null && _b !== void 0 ? _b : [];
        const grew = dataLength > previousLengthRef.current;
        previousLengthRef.current = dataLength;
        if (!grew || prefersReducedMotion()) {
            return;
        }
        records
            .flatMap((record) => Array.from(record.addedNodes))
            .filter((node) => node instanceof Element && node.isConnected)
            .forEach(revealElement);
    }, [dataLength]);
    return (React.createElement("div", { ref: wrapRef, style: { display: 'contents' } },
        React.createElement(LibInfiniteScroll, Object.assign({}, props))));
}
export default InfiniteScroll;
